<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>

    <v-flex>
      <core-upsert
        :config="config"
        :item="protocol"
        @saved="saved">


        <template slot='headerActions'>
          
          <v-btn
            color="secondary"
            @click="$router.push('/protocol')">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>

          <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">

                 <v-btn
                  v-on="on"
                  color="secondary"
                  @click="open_in_new()">
                  <v-icon>mdi-open-in-new</v-icon>
                </v-btn>

              </template>
              <span>Open New User Survey in new tab</span>
            </v-tooltip>


             <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">

                 <v-btn
                  v-on="on"
                  color="secondary"
                   @click="$router.push('/protocol_details/' + protocol.id)">
                  <v-icon>mdi-clipboard-edit-outline</v-icon>
                </v-btn>

              </template>
              <span>Open protocol details</span>
            </v-tooltip>

        </template>

        <template slot='actions'>
          <v-btn
            color="secondary"
            @click="rolesModal = true">
            Roles
          </v-btn>
        </template>
       
      </core-upsert>
      
    </v-flex>

    <app-roles-modal v-model="rolesModal" />

  </v-container>
</template>

<script>
import { getDetail } from '@/api/base_entity'
import config from './config_index.js'

export default {
  inheritAttrs: false,
  data () {
    return {
      rolesModal: false,
      config,
      protocol: {},
      itemId: null,
      openDrugs: false,
      hiddenFields: {},
      isNew: true
    }
  },
  async created () {
    if (this.$route.params.id !== 'new') {
      this.protocol = await getDetail('protocol', this.$route.params.id)
       this.isNew = false
    }
    this.hiddenFields = { protocol_id: this.protocol.id }

  },
  mounted () {
  },
  methods: {
    saved (item) {
      this.itemId = Number(item.assetId)
      this.isNew = false
      this.hiddenFields = { protocol_id: this.itemId }
    },
    open_in_new() {
      window.open(window.location.origin + '/#/new_user/' + this.protocol.uuid, '_blank')
    }
  }
}
</script>

<style>
#core-view {
  padding-bottom: 100px;
}

.theme--light.v-label {
  font-size: 14px;
  color: #aaa;
  font-weight: 400;
}
</style>
